import React from 'react'
import PropTypes from 'prop-types';

import './horizontalPopUp.scss';

const HorizontalPopUp = props => {
    const {children, isVisible} = props;
    return (        
        <div id="horizontalPopUp" className={`${isVisible ? 'f-horizontal-popup f-horizontal-popup--active' : 'f-horizontal-popup'}`}>
           { children }          
        </div>
    )
};

HorizontalPopUp.propTypes = {
    children: PropTypes.node.isRequired,
    isVisible: PropTypes.bool.isRequired
};

export default HorizontalPopUp
